export default __webpack_public_path__ + "static/media/DropdownCircleWhite.3bd07353.svg";